import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.command.nutzungsbedingungen';
import * as api from '../../../clients/benutzerverwaltung';

@Injectable()
export class BenutzerverwaltungNutzungsbedingungenEffects {

    Nutzungsbedingungen$ = createEffect(() => this.actions$.pipe(
        ofType(ac.POST_NUTZUNGSBEDINGUNGEN),
        mergeMap((x: ac.PostNutzungsbedingungenAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().postNutzungsbedingungen(x.benutzerNutzungsBedingungenRequest).pipe(
                map((result: any) => {
                    return new ac.PostNutzungsbedingungenErfolgreichAction(result, x.benutzerNutzungsBedingungenRequest, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.PostNutzungsbedingungenFehlerAction(error, x.benutzerNutzungsBedingungenRequest, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.BenutzerverwaltungCommandService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.BenutzerverwaltungCommandService {
        if (this.service === null) {
            this.service = this.injector.get(api.BenutzerverwaltungCommandService);
        }
        return this.service;
    }
}
